import { SimOffIcon } from './SimOffIcon';

/**
 * author: Google
 * id 65B6C060-C1A9-4049-A6B6-FEAC02A899D3
 * name sim-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sim-off.svg
 * tags
 * - Cellphone / Phone 
 */
export const SignalCellularNoSimIcon = SimOffIcon;
export default SignalCellularNoSimIcon